<template>
  <v-dialog persistent v-model="dialog" scrollable @keydown.esc="dialog = false" width="850">
    <FundingAppropriationForm 
      ref="fundingAppropriationForm" 
      :dialog.sync="dialog" 
      @refresh="$emit('refresh')" 
      @itemAdded="$emit('itemAdded', $event)">
    </FundingAppropriationForm>
  </v-dialog>
</template>
<script>
  import FundingAppropriationForm from '@components/form/add-edit/FundingAppropriationForm'
export default {
  components: {
    FundingAppropriationForm,
  },
  data: () => ({
    dialog: false,
  }),
  created() {},
  computed: {
  },
  methods: {
    editFundingAppropriation(entry) {
      this.dialog = true
      this.$nextTick(() => {
        this.$refs.fundingAppropriationForm.editFundingAppropriation(entry)
      })
    },
    addFundingAppropriation() {
      this.dialog = true
      this.$nextTick(() => {
        this.$refs.fundingAppropriationForm.addFundingAppropriation()
      })
    },
  },
  } 
  
</script>
<style>

</style>